import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
// import {
//   subDays,
//   subMonths,
//   subYears,
//   startOfQuarter,
//   endOfQuarter,
// } from "date-fns";
// import { BasicSelect } from "./BasicSelect";
import { BasicDatePicker } from "./BasicDatePicker";
import { formatUTCForDB, ukWallTimeToUTC } from "../../utils/functions";

// Optional display props; the defaults keep the ROTA page unchanged
const DateFilter = forwardRef(
  (
    {
      onFilterChange,
      dateFormat = "dd/MM/yyyy - HH:mm aa",
      startPlaceholder = "Start",
      endPlaceholder = "End",
      height,
      initialStartDate = "",
      initialEndDate = "",
      startLabelledBy,
      endLabelledBy,
    },
    ref
  ) => {
    const [selectedRange, setSelectedRange] = useState("");
    const [customRange, setCustomRange] = useState({
      startDate: initialStartDate,
      endDate: initialEndDate,
    });

    useEffect(() => {
      if (selectedRange === "custom") {
        setCustomRange({
          startDate: "",
          endDate: "",
        });
      }
    }, [selectedRange]);

    const handleClearFilter = () => {
      setSelectedRange("");
      setCustomRange({
        startDate: "",
        endDate: "",
      });
    };
    useImperativeHandle(ref, () => ({
      handleClearFilter,
    }));

    // Handle custom date range change
    const handleCustomRangeChange = (e, name) => {
      setCustomRange((prevState) => ({ ...prevState, [name]: e }));
    };

    useEffect(() => {
      if (customRange.startDate !== "" || customRange.endDate !== "") {
        const { startDate, endDate } = customRange;
        // Picked filter bounds are UK wall time; the API compares against
        // UTC-stored shift times, so convert before sending
        onFilterChange({
          startDate:
            startDate &&
            formatUTCForDB(ukWallTimeToUTC(startDate), "yyyy-MM-dd HH:mm:ss"),
          endDate:
            endDate &&
            formatUTCForDB(ukWallTimeToUTC(endDate), "yyyy-MM-dd HH:mm:ss"),
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customRange]);

    return (
      <div>
        <div>
          {/* {selectedRange === "custom" && ( */}
          <div className="d-flex al-i-c" style={{ gap: "10px" }}>
            <BasicDatePicker
              selectsStart
              dateFormat={dateFormat}
              timeFormat="HH:mm"
              popperPlacement="bottom-start"
              value={customRange.startDate}
              onChange={(e) => handleCustomRangeChange(e, "startDate")}
              placeholder={startPlaceholder}
              height={height}
              ariaLabelledBy={startLabelledBy}
              startDate={customRange.startDate}
              endDate={customRange.endDate}
            />

            <BasicDatePicker
              dateFormat={dateFormat}
              timeFormat="HH:mm"
              popperPlacement="bottom-start"
              selectsEnd
              value={customRange.endDate}
              onChange={(e) => handleCustomRangeChange(e, "endDate")}
              placeholder={endPlaceholder}
              height={height}
              ariaLabelledBy={endLabelledBy}
              startDate={customRange.startDate}
              endDate={customRange.endDate}
              minDate={customRange.startDate}
            />
          </div>
          {/* )} */}
        </div>
      </div>
    );
  }
);

export default DateFilter;
